import { Loader2 } from 'lucide-react';

export default function LoadingIndicator({
    color,
}: {
    color?: string;
}) {
    return (
        <div className="flex items-center justify-center py-8">
            <Loader2
                className="size-4 animate-spin text-muted-foreground"
                style={color ? { color } : undefined}
            />
            <span className="sr-only">Loading...</span>
        </div>
    );
}
